import * as React from "react";
import { forwardRef } from "react";
const SvgChervonRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 20, viewBox: "0 0 12 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2 18L10 10L2 2", stroke: "#5777DA", strokeWidth: 3.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgChervonRight);
export { ForwardRef as ReactComponent };
